import {useContext} from "react";
import {IAccountRecordingsContext} from "../contexts/models/Account/IAccountRecordingsContext.ts";
import {AccountRecordingsContext} from "../contexts/Account/AccountRecordingsContext.tsx";

export const useAccountRecording = () => {
    return useContext<IAccountRecordingsContext>(AccountRecordingsContext);
}